import React, { useState, useEffect } from "react";
import { Row, Col, Card, Accordion } from "react-bootstrap";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
function AddRole() {
  var history = useHistory();
  const [name, setName] = useState("");
  const [getData, setGetData] = useState([]);
  const [permissionList, setPermissionList] = useState([]);
  const Permission = [
    {
      title: "Dashboard",
      sub: ["Dashboard"],
    },
    {
      title: "K Health Users",
      sub: ["All Users", "Deleted User","User Analytics"],
    },
    {
      title: "Riders",
      sub: [
        "Riders",
        "Riders Applied",
        "Blocked Riders",
        "Training",
        "Rider Map View",
        "Rejected Riders",
      ],
    },
   
   
  
    {
      title: "Order List",
      sub: ["AllOrders","Order Ratings"],
    },
    {
      title: "Geofence",
      sub: ["Geofences","Create Geofence","All Geofence"],
    },
    {
      title: "Staff",
      sub: ["All Staff", "Roles"],
    },
    {
      title: "Serviceable Area",
      sub: ["Serviceable Area"],
    },
    {
      title: "Marketting",
      sub: [
        "Banners",
        "Trending Banners",
        "Go One Category",
        "CashBack",
        "Movers Categories",
        "Customer Notification",
        "Go One Coupens",
        "Quotes",
        "Offers"
      ],
    },
    {
      title: "Analytics",
      sub: ["Category Analytics","All Analytics"],
    },
    {
      title: "Support",
      sub: ["Rider Support", "Customer Support", "FAQ","App Update"],
    },
   
    {
      title: "Transactions",
      sub: ["Transactions","Payment Options"],
    },
    
    
    {
      title: "Diagnostics",
      sub: [
        "Tests",
        "Package Category",
        "Main Category",
        "Packages",
        "Package Banner",
        "Health Centers",
        "Sub Tests",
        "Rider Register",
        "Delivery Charge"
      ],
    },
   
  ];
  function getRoleData() {
    axios
      .get(`${Baseurl.baseurl}/roles/get-roles`)
      .then((response) => {
        setGetData(response.data.details);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  useEffect(() => {
    getRoleData();
  }, []);
  function removeDuplicates(arr) {
    var counts = arr.reduce(function (counts, item) {
      counts[item] = (counts[item] || 0) + 1;
      return counts;
    }, {});
    return Object.keys(counts).reduce(function (arr, item) {
      if (counts[item] === 1) {
        arr.push(item);
      }
      return arr;
    }, []);
  }

  const onSbmitHandle = (e) => {
    e.preventDefault();
    var per = removeDuplicates(permissionList);
    const artical = {
      title: name,
      permission: per,
    };
    axios
      .post(`${Baseurl.baseurl}/roles/add-roles`, artical)
      .then((response) => {
        if (response.data.status) {
          setName("");
          setPermissionList("");
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  };
  function addPermission(val) {
    setPermissionList(
      (oldArray) => oldArray.concat(val),
      () => {}
    );
  }
  return (
    <>
      <div className="row">
        <div className="col-xl-12 col-lg-12">
          <div
            className="card"
            style={{
              color: "white",
              background:
                "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
            }}
          >
            <div className="card-header">
              <h4 className="card-title text-white">Add Roles</h4>
              <button
                className="btn btn-primary"
                onClick={() => {
                  history.push("/all-roles");
                }}
              >
                Back
              </button>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <form>
                  <div className="form-group row">
                    <label className="col-sm-2 col-form-label">Name</label>
                    <div className="col-sm-4">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Roll name"
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group col">
                    <label>Select Permissions</label>
                    {Permission.map((val) => {
                      return (
                        <div className="row ml-5">
                          <div className="col-sm-3">
                            <i className="fa fa-circle mr-2"></i>
                            {val.title}
                          </div>
                          <div className="">
                            <br></br>
                            {val.sub.map((val) => {
                              return (
                                <div>
                                  <input
                                    onClick={() => addPermission(val)}
                                    type="checkbox"
                                    className="mb-3"
                                    id="checkAll"
                                    required
                                  />
                                  <span className="ml-2">{val}</span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </form>
                <div className="row">
                  <div className="col-sm-6"></div>
                  <div className="col-sm-2">
                    <button className="btn btn-primary" onClick={onSbmitHandle}>
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddRole;
